import { safeLocalStorage } from '@/shared/lib/storage';

export type Tokens = {
    accessToken: string;
    idToken: string;
    refreshToken: string;
};

export type UpdateTokens = {
    accessToken: string;
    idToken: string;
};

type JwtPayload = {
    exp: number;
    iat?: number;
    sub?: string;
};

const STORAGE_KEYS = {
    ACCESS_TOKEN: 'accessToken',
    ID_TOKEN: 'idToken',
    REFRESH_TOKEN: 'refreshToken',
} as const;

export const saveTokens = (tokens: Tokens): void => {
    safeLocalStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken);
    safeLocalStorage.setItem(STORAGE_KEYS.ID_TOKEN, tokens.idToken);
    safeLocalStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, tokens.refreshToken);
};

export const updateStoredTokens = (tokens: UpdateTokens): void => {
    safeLocalStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken);
    safeLocalStorage.setItem(STORAGE_KEYS.ID_TOKEN, tokens.idToken);
};

export const getStoredTokens = (): Tokens | undefined => {
    const accessToken = safeLocalStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    const idToken = safeLocalStorage.getItem(STORAGE_KEYS.ID_TOKEN);
    const refreshToken = safeLocalStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);

    if (!accessToken || !idToken || !refreshToken) return undefined;
    return { accessToken, idToken, refreshToken };
};

export const clearStoredTokens = (): void => {
    safeLocalStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    safeLocalStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
    safeLocalStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
};

const decodeJwtPayload = (token: string): JwtPayload | null => {
    const [, payload = ''] = token.split('.');
    try {
        return JSON.parse(atob(payload)) as JwtPayload;
    } catch {
        return null;
    }
};

export const isTokenExpired = (token: string): boolean => {
    const payload = decodeJwtPayload(token);

    if (!payload) return true;
    return Date.now() / 1000 > payload.exp;
};
